import React from 'react'
import { Link } from 'react-router-dom'

import { Client } from 'utils'
import styles from './Home.module.scss'

class Home extends React.Component {
  state = {}

  componentDidMount() {
    this.client.getProfile().then(user => {
      this.setState({ user })
    })
  }

  client = new Client()

  render() {
    if (!this.state.user) {
      return null
    }

    return (
      <div className={styles.container}>
        <Link className={styles.button} to='/search'>
          Buscar Questão
        </Link>
        <Link to='/create' className={styles.button}>
          Criar Questão
        </Link>
      </div>
    )
  }
}

export default Home
